import React from "react";

const Privacy = (props) => {
  return (
    <div class="article">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1>Юридическая информация</h1>
            <div class="col-xs-12">
              <h2>1. Издатель сайта</h2>
              <p>
                Сайт davoyage.com издаётся <strong>Давидом Имирзяном</strong>,
                торговое наименование <strong>Davoyage</strong>,
                индивидуальный предприниматель (Entrepreneur Individuel,
                Франция).
                <br />
                Юридический адрес: 10 rue de Nazareth, 69003 Lyon, France
                <br />
                SIREN: 479 817 249
                <br />
                SIRET (головное предприятие): 479 817 249 00010
                <br />
                Номер плательщика НДС: FR83479817249
                <br />
                Регистрация VTC (Atout France): EVTC069140133
                <br />
                Директор публикации: David Imirzian
                <br />
                Контакт: <a href="mailto:contact@davoyage.com">contact@davoyage.com</a> — +33 6 60 26 53 36
              </p>

              <h2>2. Хостинг</h2>
              <p>
                Сайт размещён на серверах Amazon Web Services EMEA SARL,
                38 avenue John F. Kennedy, L-1855 Luxembourg.
              </p>

              <h2>3. Интеллектуальная собственность</h2>
              <p>
                Всё содержимое сайта (тексты, изображения, логотипы,
                структура) защищено авторским правом. Любое
                воспроизведение, представление или распространение,
                полное или частичное, без предварительного разрешения
                Davoyage запрещено и является нарушением авторских прав.
              </p>

              <h2>4. Персональные данные</h2>
              <p>
                Информация, собираемая через форму запроса расчёта
                (имя, email, телефон, адреса поездки), используется
                исключительно для обработки вашего запроса и никогда не
                продаётся и не передаётся третьим лицам, кроме случаев,
                строго необходимых для оказания услуги (оплата,
                маршрутизация поездки).
              </p>
              <p>
                В соответствии с Общим регламентом по защите данных
                (GDPR) и французским законодательством о защите данных,
                вы имеете право на доступ, исправление, удаление и
                возражение в отношении ваших данных. Чтобы воспользоваться
                этим правом, свяжитесь с нами:{" "}
                <a href="mailto:contact@davoyage.com">contact@davoyage.com</a>.
              </p>

              <h2>5. Медиация потребительских споров</h2>
              <p>
                В соответствии с французским законодательством (статья
                L.616-1 Потребительского кодекса) любой клиент-потребитель
                имеет право бесплатно обратиться к медиатору по
                потребительским спорам для досудебного урегулирования
                спора с Davoyage.
              </p>

              <h2>6. Применимое право и споры</h2>
              <p>
                Настоящий сайт и условия его использования регулируются
                французским правом. В случае спора, при невозможности
                досудебного урегулирования, исключительную компетенцию
                имеют суды города Лиона (Франция).
              </p>
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
